import React from 'react';
import loadable from '@loadable/component';
import connectRoute from 'app/routes/connectRoute';
import InterlibraryLoansActions from 'app/actions/InterlibraryLoansActions';
import { currentAccountSelector } from 'app/selectors/AuthSelector';

const PrintInterlibraryLoansContainer = loadable(() => import('app/containers/print/PrintInterlibraryLoansContainer'));

export function PrintInterlibraryLoansPageRoute() {
  return <PrintInterlibraryLoansContainer />;
}

function getRouteData({ dispatch, state, params, query }) {
  const account = currentAccountSelector(state);
  const accountId = account && account.get('id');
  if (!accountId) return [];

  return [
    dispatch(
      InterlibraryLoansActions.fetchInterlibraryLoans({
        accountId,
        ...params,
        ...query
      })
    )
  ];
}

export default connectRoute(PrintInterlibraryLoansPageRoute, { getRouteData });
